import createClient from 'openapi-react-query';
import { apiClient } from './client';

// Create the openapi-react-query client using our existing fetch client
export const $api = createClient(apiClient);

// Export type for the client
export type ApiQueryClient = typeof $api;